import { AfterViewInit, Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild} from "@angular/core";
import { DragAndDropPanel, DragAndDropPanelItem } from "./drag-drop-panel";
import { INode, Rect, SimpleNode } from "@yfiles/yfiles";
import { NodeService } from "../../model-services/node.service";
import { isOrganisationNode, NODE_SUPERTYPE } from "../../common/linqset-model";
import { LinqNodeStyle } from "../styles/linq-node-style";
import { NodeStyleSettings } from "../../ui-components/svgs/node-svgs";

// the node types that can be dragged onto the canvas; on small screens one of each kind, otherwise every type for the model
@Component({
    selector: 'app-node-palette',
    templateUrl: 'node-palette.html',
    styleUrls: ['node-palette.css'],
    standalone: false
})
export class NodePaletteComponent implements OnChanges, AfterViewInit {
    @Input() isOrganisationModel:boolean = false
    @Input() smallScreen:boolean = false

    // this palette's own element; a page-wide id could find another palette, or nothing before this one is drawn
    @ViewChild('dndPanel', {static: true}) panelElement:ElementRef<HTMLElement>

    dragAndDropPanel:DragAndDropPanel

    constructor(private nodeService:NodeService) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["smallScreen"]?.currentValue != changes["smallScreen"]?.previousValue || changes["isOrganisationModel"]?.currentValue != changes["isOrganisationModel"]?.previousValue)
            this.createPanel()
    }

    ngAfterViewInit(): void {
        if (!this.dragAndDropPanel) this.createPanel()
    }

    createPanel() {
        const element = this.panelElement?.nativeElement
        if (!element) return
        if (!this.dragAndDropPanel) {
            this.dragAndDropPanel = new DragAndDropPanel(element)
            this.dragAndDropPanel.maxItemWidth = 50
        }

        this.dragAndDropPanel.clearPanel()

        const data = this.createDnDPanelItems()
        this.dragAndDropPanel.populatePanel(data)
    }

    createDnDPanelItems() {
        const itemContainer: DragAndDropPanelItem<INode>[] = []
        if (this.smallScreen) {
            this.nodeService.nodeSuperTypes.forEach(st => {
                if ((this.isOrganisationModel && isOrganisationNode(st.superType)) || (!this.isOrganisationModel && (st.superType !== NODE_SUPERTYPE.PEOPLE && st.superType !== NODE_SUPERTYPE.INFRASTRUCTURE))) {
                    const settings = new NodeStyleSettings()
                    settings.type = st.nodeTypes[0].type

                    const node = new SimpleNode({
                        layout: new Rect(0, 0, 35, 35),
                        style: new LinqNodeStyle(settings),
                        tag: {node: {superType:st.superType, type:settings.type}}
                    })
                    itemContainer.push({ modelItem: node, tooltip: st.nodeTypes[0].description })
                }
            })
        }else {
            this.nodeService.nodeSuperTypes.forEach(st => {
                st.getModelPalette(this.isOrganisationModel).forEach(i => {
                    const settings = new NodeStyleSettings()
                    settings.type = i.type
                    const node = new SimpleNode({
                        layout: new Rect(0, 0, 35, 35),
                        style: new LinqNodeStyle(settings),
                        tag: {node: {superType:i.superType, type:settings.type}}
                    })
                    itemContainer.push({ modelItem: node, tooltip: i.description })
                })
            })
        }
        return itemContainer
    }
}